// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.order-log-drawer .el-drawer__header { border-bottom: 1px solid #e5e6eb; margin-bottom: 0; padding: 20px;\n}\n.order-log-drawer .preStyle { height: calc(100vh - 70px); overflow: hidden;\n}\n.order-log-drawer .messageCon { background: #f7f8fa;\n}\n.order-log-drawer pre { max-height: 500px; overflow: auto; white-space: break-spaces; margin: 0; padding: 0 10px; line-height: 26px;\n}\n", ""]);
// Exports
module.exports = exports;
